import React from 'react';
import PropTypes from 'prop-types';
// import debounce from 'lodash.debounce';

// Components
// SVGs
// Constants
// Styles
import './SearchInput.css';

export default class SearchInput extends React.Component {
  // Prop Types
  // ------------------------------------------------------------------------ //
  static propTypes = {
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    type: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string
  };
  static defaultProps = {
    // type: 'search',
    type: 'text',
    className: '',
    onKeyDown: () => {}
  };

  // Constructor
  // ------------------------------------------------------------------------ //
  // constructor(props) {
  //   super(props);
  // }

  // Variables
  // ------------------------------------------------------------------------ //

  // Lifecycle methods
  // ------------------------------------------------------------------------ //

  // Event handlers
  // ------------------------------------------------------------------------ //

  // Class methods
  // ------------------------------------------------------------------------ //

  // Render methods
  // ------------------------------------------------------------------------ //
  render() {
    return (
      <div 
        className={`
          search-input
          ${this.props.className}
        `}
      >
        <input
          className="search-input__input"
          name={this.props.name}
          type={this.props.type}
          placeholder={this.props.placeholder}
          value={this.props.value}
          onBlur={this.props.onBlur}
          onFocus={this.props.onFocus}
          onChange={this.props.onChange}
          onKeyDown={this.props.keyDown}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/_shared/SearchInput/SearchInput.js